import { get_token} from "@/router";
import Swal from 'sweetalert2';

export default {
    name: 'FolderView',
    props:{

        folder: Object
  
    },
    mounted(){
        this.fetch_document_warehouse_folders();
    },
    data() {
      return ({
        folders: [],
        currentFolderName: '',
        selectedSubfolder: null,
        isLoading: false,
      });   
    },
    watch: {
      folderId: {
        immediate: true,
        handler(newId) {
          if (newId !== undefined && newId !== null) {
            this.fetch_document_warehouse_folders(newId);
          }
        }
      }
    },
    methods: {
        getToken() {
            return get_token();
          },
          openFolder() {
            this.$emit('open-folder', this.folder);
          }
,      
        fetch_document_warehouse_folders(newId) {
          if (!newId) {
            console.warn("Invalid folder ID", newId);
            return;
          }
        
            const payload = {
                portal_id: this.$route.params.portal_id,
                parent_folder_id : newId
            }
    
            const params = new URLSearchParams(payload).toString();
            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_information/?${params}`,
              method: 'GET',
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              success: (response) => {
                this.folders = response.data;
                      // Optionally update the folder name if available
                if (response.data.length > 0) {
                  this.currentFolderName = response.data[0].parent_folder_name || '';
                } else {
                  this.currentFolderName = 'Empty Folder';
                }
      
                setTimeout(() => {
      
                  this.loading = false;
                }, 1000);
              },
              complete: () => {
                this.isLoading = false;
              }
            });
          },
          openSubfolder(folder) {
            this.selectedSubfolder = folder;
          },
         delete_folder(folder_id){         
            const payload = {
              folder_id: folder_id,
            };
            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder/`,
              method: 'POST',
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(payload),
              success: (data) => {
                if (data.status === "success") {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Folder deleted.',
                    showConfirmButton: false,
                    timer: 1000
                  }).then(() => {
                    Swal.close();
                    this.$emit('folder-deleted', folder_id);
                
                    
                  });
                }
              },
              complete: () => {
                this.isLoading = false;
              }
            });
             }
    }
  };